module.exports = __webpack_public_path__ + "img/translate4.830c0459.jpg";